import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DigitalBadgeCourseData } from 'src/model/VideoCourses/DigitalBadgeCourseData';
import { CoursewareService } from 'src/services/CoursewareService';
import { Breadcrumb } from 'src/model/Breadcrumb';
import { ActivatedRoute } from '@angular/router';
import { ExamQuestion } from 'src/model/ExamQuestion';
import { ExamStatus } from 'src/model/ExamStatus';
import { globals } from '../shared/globals';
import { AlertService } from '../_alert';
import { Error } from 'src/model/Error';
import { timer } from 'rxjs';

@Component({
    selector: 'app-exam',
    templateUrl: './exam.component.html',
    styleUrls: ['./exam.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class ExamComponent implements OnInit {

    digitalBadgeCourseData: DigitalBadgeCourseData;
    ID: string;
    breadcrumbs: Breadcrumb[] = [];
    examQuestion: ExamQuestion = null;
    answer: string = null;
    examId: string = null;
    startTime = null;
    timeRemaining = null;

    constructor(private route: ActivatedRoute, private coursewareService: CoursewareService, private alertService: AlertService) { }

    ngOnInit() {
        this.ID = this.route.snapshot.paramMap.get('id');
        this.breadcrumbs = JSON.parse(this.route.snapshot.paramMap.get('breadcrumbs'));
        //this.breadcrumbs = (Breadcrumb[])this.route.snapshot.paramMap.get('breadcrumbs');

        this.coursewareService.getExam(this.ID, globals.token).subscribe(data => {
            this.digitalBadgeCourseData = data;
            if (!this.digitalBadgeCourseData.ID) {
                this.digitalBadgeCourseData = null;
                let error: Error = data;
                this.alertService.error(error.Message);
            }
        });
    }

    canStartExam() {
        if (!this.digitalBadgeCourseData)
            return false;
        //   if (this.digitalBadgeCourseData.examStatus == ExamStatus.NotStarted || this.digitalBadgeCourseData.examStatus == ExamStatus.Failed)
        return true;
        return false;
    }

    hasPassed() {
        if (!this.digitalBadgeCourseData)
            return false;
        if (this.digitalBadgeCourseData.examStatus == ExamStatus.Passed)
            return true;
        return false;
    }

    hasAnsweredAllQuestions() {
        if (!this.digitalBadgeCourseData)
            return false;
        if (this.digitalBadgeCourseData.examStatus == ExamStatus.AllQuestionsAnswered)
            return true;
        return false;
    }


    clickRadio(event) {
        var target = event.target || event.srcElement || event.currentTarget;
        var idAttr = target.attributes.id;
        var value = idAttr.nodeValue;
        this.answer = value;
        //        console.log("clickRadio=" + value);
    }

    displayExam() {
        if (!this.examQuestion) {
            return false;
        }
        if (this.examQuestion.examStatus == null) {
            return false;
        }
        if (this.examQuestion.examStatus == ExamStatus.HasUnansweredQuestions) {
            return true;
        }
        return false;
    }

    displayExamOver() {
        if (this.examQuestion && this.examQuestion.examStatus && (this.examQuestion.examStatus == ExamStatus.AllQuestionsAnswered || this.examQuestion.examStatus == ExamStatus.Failed || this.examQuestion.examStatus == ExamStatus.Cancelled || this.examQuestion.examStatus == ExamStatus.Passed)) {
            return true;
        }
        return false;
    }

    startExam() {
        this.coursewareService.startExam(this.digitalBadgeCourseData.ID, globals.token).subscribe(data => {
            let holdExamQuestion = this.examQuestion;
            this.examQuestion = data;
            if (!this.examQuestion.DigitalBadgeExamID) {
                this.examQuestion = holdExamQuestion;
                let error: Error = data;
                this.alertService.error(error.Message);
            }
            this.startTime = new Date().getTime() + 3600 * 1000;
            const source = timer(1000, 1000);
            //output: 0,1,2,3,4,5......
            const subscribe = source.subscribe(val => this.calcTimeRemaining());
            this.examId = this.examQuestion.DigitalBadgeExamID;
        });
    }

    SkipQuestion() {
        //        console.log("SkipQuestion");
        this.coursewareService.skipQuestion(this.examId, this.examQuestion.Question.ID, globals.token).subscribe(data => {
            let holdExamQuestion = this.examQuestion;
            this.examQuestion = data;
            //            console.log("SkipQuestion received data");
            if (!this.examQuestion.examStatus) {
                //                console.log("SkipQuestion got an error");
                this.examQuestion = holdExamQuestion;
                let error: Error = data;
                this.alertService.error(error.Message);
            }
        });
    }

    calcTimeRemaining() {
        let timeDiff = this.startTime - new Date().getTime();
        timeDiff = timeDiff / 1000;
        if (timeDiff <= 0) {
            this.timeRemaining = "no time remaining";
            return;
        }
        var seconds = Math.round(timeDiff % 60);
        timeDiff = Math.floor(timeDiff / 60);
        var minutes = Math.round(timeDiff % 60);
        if (seconds < 10)
            this.timeRemaining = minutes + ":0" + seconds;
        else if (seconds == 60)
            this.timeRemaining = (minutes + 1) + ":00";
        else
            this.timeRemaining = minutes + ":" + seconds;
    }

    SubmitQuestion() {
        //        console.log("SubmitQuestion");
        this.coursewareService.submitQuestion(this.examId, this.examQuestion.Question.ID, this.answer, globals.token).subscribe(data => {
            let holdExamQuestion = this.examQuestion;
            this.examQuestion = data;
            this.answer = null;
            //            console.log("SubmitQuestion received data ");
            if (!this.examQuestion.examStatus) {
                //                console.log("SubmitQuestion response invalid");
                this.examQuestion = holdExamQuestion;
                let error: Error = data;
                this.alertService.error(error.Message);
            }
        });
    }

}